import {
  Flex,
  IconButton,
  ListItem,
  Text,
  Button,
  FormControl,
  FormLabel,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  UnorderedList,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserAvatar from "components/elements/UserAvatar";
import { LoanContext } from "providers/loan";
import { ContactModel, ContactUser } from "providers/loans/contact.model";
import { useContext, useEffect, useState } from "react";
import { getUserTagline } from "utils/helpers";
import { ItemContactType } from "utils/types";

const ItemContacts = ({
  contacts,
  setContacts,
}: {
  contacts: ItemContactType[];
  setContacts: (contacts: ItemContactType[]) => void;
}) => {
  const [options, setOptions] = useState<ContactUser[]>([]);

  const { loan } = useContext(LoanContext);

  useEffect(() => {
    if (!loan || !loan.contacts) {
      return;
    }

    setOptions(
      loan.contacts.map((member: ContactModel) => member.user)
        .filter((option: ContactUser) =>
          contacts.find(
            (contact: ItemContactType) => contact.user.id === option.id,
          )
            ? false
            : true,
        ),
    );
  }, [contacts, loan]);

  return (
    <FormControl mb="20px">
      <FormLabel>Assigned Members</FormLabel>
      {contacts.length > 0 && (
        <UnorderedList listStyleType="none" p="0px" m="0px" mb="12px">
          {contacts.map((contact: any) => (
            <ListItem
              key={contact.id}
              display="flex"
              justifyContent="space-between"
              borderBottomWidth="1px"
              borderBottomColor="gray.50"
              py="12px"
            >
              <Flex alignItems="center">
                <UserAvatar size="33px" mr="12px" user={contact.user} />
                <Text fontSize="14px" color="#171B1E">
                  {contact.user.first_name} {contact.user.last_name}
                </Text>{" "}
              </Flex>
              <Flex alignItems="center">
                <Text fontSize="12px">{getUserTagline(contact.user)}</Text>
                <IconButton
                  ml="6px"
                  onClick={() =>
                    setContacts(
                      contacts.filter(
                        (c: any) => c.user.id !== contact.user.id,
                      ),
                    )
                  }
                  aria-label="remove-member"
                  variant="ghost"
                  icon={<FontAwesomeIcon icon={["far", "times"]} />}
                />
              </Flex>
            </ListItem>
          ))}
        </UnorderedList>
      )}

      <Menu>
        <MenuButton
          data-cy="add-checklist-item-member"
          as={Button}
          variant="ghost"
          color="primary"
          size="sm"
          pl="0px"
          disabled={options.length === 0}
          leftIcon={<FontAwesomeIcon icon={["far", "plus"]} />}
        >
          Add member
        </MenuButton>
        <MenuList p="10px">
          {options.map((user, index) => (
            <MenuItem
              data-cy="checklist-item-member-option"
              key={user.id}
              py="6px"
              onClick={() =>
                setContacts([
                  ...contacts,
                  {
                    id: user.id,
                    user,
                  },
                ])
              }
            >
              <Flex alignItems="center">
                <UserAvatar size="32px" mr="12px" user={user} />
                <Flex flexDir="column">
                  <Text fontSize="14px" color="secondary">
                    {user.first_name} {user.last_name}
                  </Text>
                  <Text fontSize="12px">{getUserTagline(user)}</Text>
                </Flex>
              </Flex>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </FormControl>
  );
};

export default ItemContacts;
